import { marked } from 'marked'
import markedKatex from 'marked-katex-extension'
import markedFootnote from 'marked-footnote'

marked.use(markedKatex({ throwOnError: false, nonStandard: true }))
marked.use(markedFootnote())

/** Minimal browser-safe frontmatter parser (first-colon split; values may contain ':'). */
export function parseFrontmatter(raw: string): { data: Record<string, unknown>; content: string } {
  const m = raw.match(/^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/)
  if (!m) return { data: {}, content: raw }
  const data: Record<string, unknown> = {}
  for (const line of m[1].split('\n')) {
    const i = line.indexOf(':')
    if (i === -1) continue
    const key = line.slice(0, i).trim()
    const val = line.slice(i + 1).trim()
    if (!key) continue
    if (val.startsWith('[') && val.endsWith(']')) {
      data[key] = val
        .slice(1, -1)
        .split(',')
        .map((s) => s.trim().replace(/^["']|["']$/g, ''))
        .filter(Boolean)
    } else {
      data[key] = val.replace(/^["']|["']$/g, '')
    }
  }
  return { data, content: m[2] }
}

/** Wrap wide tables so they scroll inside their own container on mobile. */
export function wrapTables(html: string): string {
  return html
    .replace(/<table(\s[^>]*)?>/g, '<div class="table-wrap"><table$1>')
    .replace(/<\/table>/g, '</table></div>')
}

/** Render a markdown/HTML body to display HTML. Published bodies are already HTML;
 *  marked passes block HTML through unchanged, so this is faithful. */
export function render(body: string): string {
  return wrapTables(marked(body) as string)
}
